import { render, staticRenderFns } from "./InitialOrderModal.vue?vue&type=template&id=411214bc&"
import script from "./InitialOrderModal.vue?vue&type=script&lang=ts&"
export * from "./InitialOrderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QTable,QTd,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QTable,QTd,QCardActions})
